import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
export class DescriptionOfItem extends React.Component {
  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  onChangeResetReceived = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    item.fromWhom = '';
    item.howMuch = '';
    item.totalExpensesClaimed = '';
    item.currencyExpensesClaimed = '';
    this.change(item);
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };
  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  render() {
    const { item } = this.props;
    const {
      disabled,
      removable,
    } = this.props;

    return (
      <div>
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className="form-group col-auto">
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
        </div>
        <div className="row">
          {/* {!disabled &&
            removable && (
              <div className="form-group col-sm-2 col-md-2">
                <Button className="mt-4" onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )} */}
          <div className="form-group col-sm-5 col-md-5">
            <PageSectionHeader>
              <FormattedMessage {...messages.prescriptionMedicinesV1} />
            </PageSectionHeader>
            <Textbox
              disabled={disabled}
              name="prescriptionMedicines"
              type="text"
              onChange={this.onChange('prescriptionMedicines')}
              value={item.prescriptionMedicines}
            />
          </div>
          <div className="mt-3 form-group col-sm-3 col-md-3">
            <PageSectionHeader>
              <FormattedMessage {...messages.dosage} />
            </PageSectionHeader>
            <Textbox
              disabled={disabled}
              name="dosage"
              type="text"
              onChange={this.onChange('dosage')}
              value={item.dosage}
            />
          </div>
          <div className="mt-3 form-group col-md-4 col-sm-4">
            <PageSectionHeader>
              <FormattedMessage {...messages.nameOfPrescribingDoctor} />
            </PageSectionHeader>
            <Textbox
              disabled={disabled}
              name="nameOfPrescribingDoctor"
              type="text"
              onChange={this.onChange('nameOfPrescribingDoctor')}
              value={item.nameOfPrescribingDoctor}
            />
          </div>
        </div>
      </div>
    );
  }
}

DescriptionOfItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Zurich.MedicalExpense/components/PrescriptionMedicinesForInjury/DescriptionOfItem.js